import React from "react";
import Swal from "sweetalert2";

const PsychForm = ({ formData, handleChange, rows, setRows, nurses }) => {
    const safeRows = rows || [];
    const addRow = () => {
        setRows([
            ...safeRows,
            {
                id: Date.now(),
                date_time: "",
                order: "",
                nurse: "",
                nurse_id: null
            }
        ]);
    };


    const removeRow = (id) => {
        if (safeRows.length === 1) return;
        Swal.fire({
            title: "Delete this entry?",
            text: "This record will be removed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
        }).then((res) => {
            if (res.isConfirmed) {
                setRows(safeRows.filter((r) => r.id !== id));
            }
        });
    };

    const handleRowChange = (id, field, value) => {
        if (field === "nurse") {
            const selectedNurse = nurses?.find(n => String(n.id) === String(value));
            setRows(safeRows.map((r) =>
                r.id === id
                    ? {
                        ...r,
                        nurse: selectedNurse ? selectedNurse.name : "",
                        nurse_id: selectedNurse ? selectedNurse.id : null
                    }
                    : r
            ));
        } else {
            setRows(safeRows.map((r) => (r.id === id ? { ...r, [field]: value } : r)));
        }
    };

    return (
        <div className="p-4">
            {/* ==== Basic Info ==== */}
            <div className="row g-3 mb-4">
                <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Name"
                            value={formData.name || ""}
                            onChange={handleChange}
                            readOnly={!!formData.patient_id || !!formData.patientId}
                        />
                        <label>Name</label>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="mrNo"
                            className="form-control"
                            placeholder="M.R No."
                            value={formData.mrNo || ""}
                            onChange={handleChange}
                        />
                        <label>M.R No.</label>
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="roomNo"
                            className="form-control"
                            placeholder="Room No."
                            value={formData.roomNo || ""}
                            onChange={handleChange}
                        />
                        <label>Room No.</label>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="consultant"
                            className="form-control"
                            placeholder="Consultant"
                            value={formData.consultant || ""}
                            onChange={handleChange}
                        />
                        <label>Consultant</label>
                    </div>
                </div>
            </div>

            {/* ==== Repeater Rows ==== */}
            <div className="col-12 mb-3">
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-3 py-1">
                    Psychiatrist Orders
                </small>
            </div>

            {safeRows.map((row) => (
                <div
                    key={row.id}
                    className="border rounded-4 p-3 mb-3 shadow-sm bg-light-subtle"
                >
                    <div className="row g-3 align-items-center">

                        {/* Date & Time */}
                        <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={row.date_time || ""}
                                    onChange={(e) => handleRowChange(row.id, "date_time", e.target.value)}
                                />
                                <label>Date & Time</label>
                            </div>
                        </div>

                        {/* Order */}
                        <div className="col-md-5">
                            <div className="form-floating form-floating-outline">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Order"
                                    value={row.order || ""}
                                    onChange={(e) => handleRowChange(row.id, "order", e.target.value)}
                                />
                                <label>Order</label>
                            </div>
                        </div>

                        {/* Nurse */}
                        <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={row.nurse_id || ""} // Mapping by ID
                                    onChange={(e) => handleRowChange(row.id, "nurse", e.target.value)}
                                >
                                    <option value="">Select Nurse</option>
                                    {nurses?.map((n) => (
                                        <option key={n.id} value={n.id}>{n.name}</option>
                                    ))}
                                </select>
                                <label>Nurse</label>
                            </div>
                        </div>

                        {/* Delete */}
                        <div className="col-md-1 text-end">
                            <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={() => removeRow(row.id)}
                            >
                                <i className="ri-delete-bin-line"></i>
                            </button>
                        </div>

                    </div>
                </div>
            ))}


            <div className="text-end mt-3">
                <button type="button" className="btn btn-outline-primary" onClick={addRow}>
                    <i className="ri-add-line"></i> Add Row
                </button>
            </div>
            {/* === Footer Section === */}
            <div className="row g-3 mt-4">
                <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="documentName"
                            value={formData?.documentName || ""}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Document Name"
                            readOnly
                        />
                        <label>Document Name</label>
                    </div>
                </div>

                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="date"
                            name="effectiveDate"
                            value={formData?.effectiveDate || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <label>Effective Date</label>
                    </div>
                </div>
            </div>

            <div className="row g-3 mt-3">
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="approvedBy"
                            value={formData?.approvedBy || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <label>Approved By</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="date"
                            name="approvedDate"
                            value={formData?.approvedDate || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <label>Date</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="text"
                            name="nextRevisionBy"
                            value={formData?.nextRevisionBy || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <label>Next Revision By</label>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                        <input
                            type="date"
                            name="nextRevisionDate"
                            value={formData?.nextRevisionDate || ""}
                            onChange={handleChange}
                            className="form-control"
                        />
                        <label>Date</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PsychForm;